var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "general-table-view" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.filteredData,
            "header-cell-style": {
              background: "rgb(48, 65, 86)",
              color: "white"
            },
            border: ""
          }
        },
        [
          _vm._l(_vm.columns, function(col) {
            return [
              _c("el-table-column", {
                key: col,
                attrs: { label: col, property: col, "min-width": "120" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-popover",
                            {
                              attrs: {
                                trigger: "hover",
                                content: _vm.getString(scope.row[col]),
                                "popper-class": "cell-popover"
                              }
                            },
                            [
                              _vm.isUrl(scope.row[col])
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "wrapper",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticStyle: { color: "#409eff" },
                                          attrs: {
                                            href: _vm.getString(scope.row[col]),
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getString(scope.row[col])
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _c(
                                    "div",
                                    {
                                      staticClass: "wrapper",
                                      attrs: { slot: "reference" },
                                      slot: "reference"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getString(scope.row[col])
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                            ]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  true
                )
              })
            ]
          })
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pageNum,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              layout: "sizes, prev, pager, next",
              total: _vm.total
            },
            on: {
              "update:currentPage": function($event) {
                _vm.pageNum = $event
              },
              "update:current-page": function($event) {
                _vm.pageNum = $event
              },
              "update:pageSize": function($event) {
                _vm.pageSize = $event
              },
              "update:page-size": function($event) {
                _vm.pageSize = $event
              },
              "current-change": _vm.onPageChange,
              "size-change": _vm.onPageChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }